import { Fragment, useState, useEffect } from "react";
import Paginator from "react-hooks-paginator";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { getSortedProducts } from "../../helpers/product";
import SEO from "../../components/seo";
import LayoutMain from "../../layouts/LayoutMain";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import ShopSidebar from "../../wrappers/product/ShopSidebar";
import ShopTopbar from "../../wrappers/product/ShopTopbar";
import ShopProducts from "../../wrappers/product/ShopProducts";
import { fetchProducts } from "../../store/slices/product-slice";
import { findCategories } from "../../helpers/utils";
import FullScreenLoading from "../../components/FullScreenLoading";
import { useTranslation } from "react-i18next";

const Shop = () => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const { category_id } = useParams();
    const categoryId = category_id || "";
    const { categories } = useSelector((state) => state.category);
    const { products, total_products, products_status } = useSelector((state) => state.product);
    const [layout, setLayout] = useState("grid three-column");
    const [sortType, setSortType] = useState("category");
    const [sortValue, setSortValue] = useState("");
    const [filterSortType, setFilterSortType] = useState("");
    const [filterSortValue, setFilterSortValue] = useState("");
    const [offset, setOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentData, setCurrentData] = useState([]);
    const [sortedProducts, setSortedProducts] = useState([]);
    let { pathname, search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const keyword = searchParams.get("keyword");

    const pageLimit = 15;

    const getLayout = (layout) => {
        setLayout(layout);
    };

    const getSortParams = (sortType, sortValue) => {
        setSortType(sortType);
        setSortValue(sortValue);
    };

    const getFilterSortParams = (sortType, sortValue) => {
        setFilterSortType(sortType);
        setFilterSortValue(sortValue);
    };

    useEffect(() => {
        if (categories.length > 0 && categoryId !== undefined) {
            getSortParams(
                "category",
                categoryId
            );
        }
    }, [categories, categoryId]);

    useEffect(() => {
        // let sortedProducts = getSortedProducts(products, sortType, sortValue);
        // const filterSortedProducts = getSortedProducts(
        //     sortedProducts,
        //     filterSortType,
        //     filterSortValue
        // );
        // sortedProducts = filterSortedProducts;
        // setSortedProducts(sortedProducts);
        // setCurrentData(sortedProducts.slice(offset, offset + pageLimit));
    }, [
        offset,
        products,
        sortType,
        sortValue,
        filterSortType,
        filterSortValue,
    ]);

    useEffect(() => {
        let filter_category_id = "";
        if (sortType === "category") {
            filter_category_id = sortValue;
        }
        if (categoryId && !filter_category_id) {
            return;
        }
        console.log(sortValue)
        let sort_by = "default";
        if (filterSortType === "filterSort") {
            sort_by = filterSortValue;
        }
        dispatch(
            fetchProducts({
                category_id: filter_category_id,
                keyword,
                offset,
                limit: pageLimit,
                sort_by,
            })
        );
    }, [
        dispatch,
        offset,
        sortType,
        sortValue,
        filterSortType,
        filterSortValue,
        keyword,
    ]);

    return (
        <Fragment>
            <SEO
                titleTemplate={t("shop__seo_title")}
                description={t("shop__seo_desc")}
            />

            <LayoutMain headerTop="visible">
                {/* breadcrumb */}
                <Breadcrumb
                    pages={[
                        { label: t("home__breadcrumb"), path: process.env.PUBLIC_URL + "/" },
                        {
                            label: t("shop__breadcrumb"),
                            path: process.env.PUBLIC_URL + pathname,
                        },
                    ]}
                />

                <div className="shop-area pt-95 pb-100">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-3 order-2 order-lg-1">
                                {/* shop sidebar */}
                                <ShopSidebar
                                    products={products}
                                    getSortParams={getSortParams}
                                    sideSpaceClass="mr-30"
                                />
                            </div>
                            <div className="col-lg-9 order-1 order-lg-2">
                                {/* shop topbar default */}
                                <ShopTopbar
                                    getLayout={getLayout}
                                    getFilterSortParams={getFilterSortParams}
                                    productCount={total_products}
                                    sortedProductCount={products.length}
                                />

                                {/* shop page content default */}
                                <ShopProducts
                                    layout={layout}
                                    products={products}
                                />

                                <FullScreenLoading visible={products_status === 'loading'} />

                                {/* shop product pagination */}
                                <div className="pro-pagination-style text-center mt-30">
                                    <Paginator
                                        totalRecords={total_products}
                                        pageLimit={pageLimit}
                                        pageNeighbours={2}
                                        setOffset={setOffset}
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                        pageContainerClass="mb-0 mt-0"
                                        pagePrevText="«"
                                        pageNextText="»"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </LayoutMain>
        </Fragment>
    );
};

export default Shop;
